let domain = document.domain
let BASE_URL = ''
switch (domain) {
  case 'zujuan.51jiaoxi.com':
    BASE_URL = '//www.51jiaoxi.com/api'
    break
  case 'local.paper.51jiaoxi.com':
    BASE_URL = '//test.51jiaoxi.com/api'
    break
  case 'paper.jiaoxi.com':
    BASE_URL = '//jiaoxi.com/api'
    break
  default:
    BASE_URL = '//test.51jiaoxi.com/api'
    break
}

export const $BASE_URL = BASE_URL
